// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as TbUtils13 from "../team-planner13/TbUtils13.bs.js";
import * as TeamPlannerHex13 from "../team-planner13/TeamPlannerHex13.bs.js";

function HexPreview46(Props) {
  var unitId = Props.unitId;
  var unitItems = Props.unitItems;
  var starLevel = Props.starLevel;
  var traitCounts = Props.traitCounts;
  var exaltedUnits = Props.exaltedUnits;
  return React.createElement("g", {
              transform: "translate(3, 0)"
            }, React.createElement("g", {
                  className: "scale-50 sm:scale-100"
                }, React.createElement(TeamPlannerHex13.Unit.make, {
                      isDragging: false,
                      hexSize: 50,
                      hex: {
                        unit: TbUtils13.Content.decodeStr(unitId),
                        items: unitItems,
                        starLevel: starLevel,
                        chosenTrait: 0
                      },
                      colNum: 0,
                      rowNum: 0,
                      onRemove: (function (param) {
                          
                        }),
                      onRemoveItem: (function (param, param$1, param$2) {
                          
                        }),
                      onSetStarLevel: (function (param, param$1, param$2) {
                          
                        }),
                      onToggleMech: (function (param, param$1, param$2) {
                          
                        }),
                      traitCounts: traitCounts,
                      exaltedUnits: exaltedUnits
                    })));
}

var make = React.memo(HexPreview46);

export {
  make ,
  
}
/* make Not a pure module */
